import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Loader from '../../../Components/Utility/Loader/Loader';
import CustomSectionTableList from './CustomSectionTableList';
import * as action from './store/CustomSections.action';
import AddCustomSectionTemplateModal from './AddCustomSectionTemplateModal';
import { useComponent } from '../../UserSetting/UsersLibrary/UserRights';

function RangePlanCustomSection() {
  const [state, setState] = useState({
    loader: false,
    addTemplateModalState: false,
    searchText: '',
  });
  const { addTemplateModalState, searchText } = state;
  const reducers = useSelector((redState) => redState);
  const { Users } = reducers;
  const dispatch = useDispatch();
  const { t } = useTranslation('common');

  const handleSearch = async (e) => {
    const targetValue = e.target.value;
    setState((preState) => ({
      ...preState,
      searchText: targetValue,
    }));
  };
  const { logInRights } = Users;

  const { CheckActionPermission } = useComponent();

  const planAddEditAccess = CheckActionPermission(logInRights, 'rangePlan', 'custom', 'addEdit');

  useEffect(() => {
    setState((preState) => ({ ...preState, loader: true }));
    const res = dispatch(action.fetchCustomSectionList());
    if (res) {
      setState((preState) => ({ ...preState, loader: false }));
    }
  }, [dispatch]);

  const handleModalState = (modalState) => {
    setState((preState) => ({
      ...preState,
      addTemplateModalState: modalState,
    }));
  };
  const expandSearchRefBin = useRef(null);
  const handleIconBinClick = () => {
    // Add a class to the input on icon click
    expandSearchRefBin.current.classList.toggle('active-input');
  };
  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container">
          <h4 className="title">{t('RANGE_PLANS.CUSTOM_SECTION.INDEX.PAGE_TITLE')}</h4>
        </div>
        <div className="search-filter">
          <div ref={expandSearchRefBin} className="common-expand-search">
            <button type="button" onClick={handleIconBinClick} className="btn btn-toggle">
              <span className="sr-only">Search</span>
              <span className="icon-Magnifying-Glass-Solid" />
            </button>

            <input
              onChange={(e) => handleSearch(e)}
              name="search"
              className="form-control"
              type="text"
              style={{ height: '33px' }}
              value={searchText}
              placeholder={t('DEVLOPMENT_ORDER.TESTING.PRODUCT_TESTING.SEARCH')}
            />
          </div>
          <div className="action-icons-container">
            <Link className="btn" to="/rangeplan/product-list">
              <i className="icon-close f-20" />
            </Link>
          </div>
          <div className="floting-actions">
            {planAddEditAccess && (
              <button type="button" aria-label="Add" className="btn" onClick={() => handleModalState(true)}>
                <i className="icon-Add f-26" />
              </button>
            )}
          </div>
        </div>
      </div>
      <div className="container-fluid py-4">{state.loading ? <Loader /> : <CustomSectionTableList searchText={searchText} />}</div>
      {addTemplateModalState && <AddCustomSectionTemplateModal isOpen={addTemplateModalState} handleModalState={handleModalState} />}
    </>
  );
}

export default RangePlanCustomSection;
